"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_APPLICABLE = void 0;
exports.NOT_APPLICABLE = 'N/A';
